import React from 'react';
import { Layout } from 'tea-component';
import { useIntl } from 'umi';
import zh from './sentiment_zh.md';
import en from './sentiment_en.md';
import '../styles/criteria.scss';
import MDShow from '../components/mdShow';
import ContentBody from '@/pages/opinion/components/ContentBody';
const { Body, Content } = Layout;
const mdSrcMap: { [key: string]: string } = {
  'en-US': en,
  'zh-CN': zh,
};

export default function SentimentCriteria() {
  const { formatMessage } = useIntl();
  return (
    <Layout className="dbo-page criteria-wrapper">
      <Body>
        <Content>
          <ContentBody
            contentHeard={
              <Content.Header
                title={formatMessage({ id: 'Sentiment Criteria' })}
              ></Content.Header>
            }
          >
            <MDShow mdFileMap={mdSrcMap}></MDShow>
          </ContentBody>
        </Content>
      </Body>
    </Layout>
  );
}
